import { useEffect, useState } from 'react'
import CloseSvg from '../assets/img/svg/close'
import SaveSvg from '../assets/img/svg/save'
import API from '../hooks/requests'
import FormWebhook from '../enties/form-webhook'
import StopSvg from '../assets/img/svg/stop'
import TrashSvg from '../assets/img/svg/trash'
import RefreshSvg from '../assets/img/svg/refresh'

const EditWebhook = ({
  editWebhook,
  close,
  pipelineGet,
  setPipelineGet,
  pipelineNameGet,
  setPipelineNameGet,
  keyGet,
  setKeyGet,
  toast,
  setDataList,
  toastID,
  setToastID,
  refresh,
}) => {
  const [load, setLoad] = useState(false)
  const [optPipeline, setOptPipeline] = useState([])

  useEffect(() => {
    setLoad(true)
    if (editWebhook) {
      API.getPipelineList().then((r) => {
        setOptPipeline(r.data.data)
        setLoad(false)
      })
    }
  }, [editWebhook])

  return (
    editWebhook && (
      <div className="modal-column">
        <div className="modal-topbar">
          <div className="modal-close" onClick={close}>
            <CloseSvg />
            <span>Back to list</span>
          </div>
          <div className="modal-topbar-title">Webhook #{editWebhook.id}</div>
          <div className="modal-topbar-btn">
            <div
              className="modal-delete"
              onClick={() => {
                if (!toastID) {
                  const toastId = toast(
                    ({ closeToast }) => {
                      return (
                        <div className="notify_-delete">
                          <div className="notify_-delete-title">
                            <TrashSvg />
                            <span>Confirm delete of webhook!</span>
                          </div>
                          <div className="notify_-delete-btn">
                            <span
                              className="notify_-delete-btn-del"
                              onClick={() => {
                                close()
                                setToastID(null)
                                API.deleteWebhook(editWebhook.id)
                                  .then(() => {
                                    API.getWebhooksList()
                                      .then((r) => {
                                        setDataList(r.data.data)
                                      })
                                      .catch((e) => console.log(e))
                                  })
                                  .catch((e) => console.log(e))
                              }}
                            >
                              Delete
                            </span>
                            <span
                              className="notify_-delete-btn-can"
                              onClick={() => {
                                closeToast()
                                setToastID(null)
                              }}
                            >
                              Cancel
                            </span>
                          </div>
                        </div>
                      )
                    },
                    { autoClose: false, closeButton: false }
                  )
                  setToastID(toastId)
                }
              }}
            >
              <TrashSvg />
            </div>
            <div className="modal-edit" onClick={() => refresh()}>
              <RefreshSvg />
            </div>
            <div
              className="modal-save"
              onClick={() => {
                API.changeWebhook(editWebhook.id, {
                  key: keyGet || editWebhook.key,
                  pipeline: pipelineGet || editWebhook.pipeline,
                  name: pipelineNameGet || editWebhook.name,
                })
                  .then(() => {
                    close()
                    API.getWebhooksList()
                      .then((r) => {
                        setDataList(r.data.data)
                      })
                      .catch((e) => console.log(e))
                  })
                  .catch((e) => {
                    if (
                      e.status === 400 &&
                      e.response.data.msg === 'Key is already in use'
                    ) {
                      toast(
                        <span className="notify_-copy-link">
                          <StopSvg />
                          <span>Key is already in use!</span>
                        </span>
                      )
                    }
                  })
              }}
            >
              <SaveSvg />
            </div>
          </div>
        </div>
        {load ? (
          <div className="load-data">Getting data from pipelines...</div>
        ) : (
          <div className="create-bundle-webhook">
            <FormWebhook
              pipeline={pipelineGet || editWebhook.pipeline}
              keyGet={keyGet || editWebhook.key}
              optPipeline={optPipeline}
              callback={(e) => {
                setPipelineGet(e.value)
                setPipelineNameGet(e.label)
              }}
              keyCallback={(e) => {
                setKeyGet(e.target.value)
              }}
            />
          </div>
        )}
      </div>
    )
  )
}

export default EditWebhook
